export default __webpack_public_path__ + "static/media/bur.8125fca1.jpg";